import React from "react";
import { Link } from "react-router-dom";
import { BUSINESS_INFO } from "../config";
import { getOptimizedImageUrl } from "../lib/utils";

export function Logo({
  className = "",
  light = false,
  showTagline = true,
  imageOnly = false,
  size = "md",
}) {
  const textColor = light ? "#FFFFFF" : "#2C2420";
  const subtextColor = light ? "#E8D8CC" : "#7A685D";

  const sizeClasses =
    {
      sm: "h-12 w-12 sm:h-14 sm:w-14",
      md: "h-16 w-16 sm:h-20 sm:w-20",
      lg: "h-20 w-20 sm:h-24 sm:w-24",
      xl: "h-24 w-24 sm:h-28 sm:w-28",
    }[size] || "h-16 w-16 sm:h-20 sm:w-20";

  return (
    <Link
      to="/"
      className={`group inline-flex items-center gap-3 sm:gap-3.5 transition-opacity hover:opacity-95 ${className}`}
      aria-label="Hundens Pels og Pleje - Gå til forsiden"
    >
      <div
        className={`relative shrink-0 overflow-hidden rounded-full ${sizeClasses} bg-[#FBF6EE] ring-2 ${
          light ? "ring-white/30 shadow-md" : "ring-[#8C532B]/20 shadow-xs"
        } transition-transform duration-300 group-hover:scale-105`}
      >
        <img
          src={getOptimizedImageUrl(BUSINESS_INFO.logoUrl, { width: 280, quality: 95 })}
          alt="Hundens Pels og Pleje logo"
          className="h-full w-full object-cover"
          loading="eager"
        />
      </div>
    </Link>
  );
}
